import { Button, Card } from 'react-bootstrap';
import { SectionTitle } from '../help/SectionTitle';

export function DangerZoneSection({
  projectName,
  deleting,
  onDelete,
}: {
  projectName: string;
  deleting: boolean;
  onDelete: () => void;
}) {
  return (
    <Card className="shadow-sm border-danger-subtle">
      <Card.Header className="border-danger-subtle">
        <SectionTitle
          title={<span className="text-danger">بخش خطر</span>}
          helpKey="danger_zone"
          subtitle={<span className="text-danger">حذف دائمی این پروژه و تمام داده‌های مرتبط.</span>}
        />
      </Card.Header>
      <Card.Body className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-sm-between gap-3">
        <p className="fs--1 text-700 mb-0">
          این کار پروژه <span className="fw-medium text-1000">{projectName}</span> را حذف می‌کند و
          قابل بازگشت نیست.
        </p>
        <Button
          type="button"
          variant="outline-danger"
          onClick={onDelete}
          disabled={deleting}
          className="flex-shrink-0"
        >
          {deleting ? 'در حال حذف…' : 'حذف پروژه'}
        </Button>
      </Card.Body>
    </Card>
  );
}
